export const SEARCH_POPUP = {
  // SearchPopup.tsx
  WRAPPER: 'search-popup-wrapper',
  CLICK_AWAY_OVERLAY: 'search-popup-click-away-overlay',
  SEARCH_INPUT_FIELD: 'search-popup-search-input-field',
  SEARCH_ICON: 'search-popup-search-icon',
  CLEAR_SEARCH_BUTTON: 'search-popup-clear-search-button',
  RELATIONSHIP_TYPE_SELECT: 'search-popup-relationship-type-select',
  RELATIONSHIP_TYPE_FS: 'search-popup-relationship-type-fs',
  RELATIONSHIP_TYPE_SS: 'search-popup-relationship-type-ss',
  RELATIONSHIP_TYPE_FF: 'search-popup-relationship-type-ff',
  RELATIONSHIP_TYPE_LIST_CONTAINER: 'search-popup-relationship-type-list-container',
  RELATIONSHIP_TYPE_LABEL: 'search-popup-relationship-type-label',
  RELATIONSHIP_TYPE_LAG_WRAPPER: 'search-popup-relationship-type-lag-wrapper',
  RELATIONSHIP_TYPE_TICK_WRAPPER: 'search-popup-relationship-type-tick-wrapper',
  CONFIRMATION_BOX: 'search-popup-confirmation-box'
} as const;
